import React, { useEffect } from 'react';
import { sendMobileLoadedNotification, setViewMeta } from '@ecs-uk/web-common-mobile-view-helpers';
import PaymentandBilling from '../../payment-and-billing';

const MobilePaymentAndBillingPage = () => {
  useEffect(() => {
    setViewMeta({ viewTitle: 'Payment and billing' });
    sendMobileLoadedNotification();
  }, []);

  return <PaymentandBilling isWebview />;
};

export default MobilePaymentAndBillingPage;
